(() => {
  const replaceText = (root, from, to) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (node.nodeValue && node.nodeValue.includes(from)) {
        node.nodeValue = node.nodeValue.split(from).join(to);
      }
    });
  };

  const syncReturnMessage = () => {
    replaceText(document.body, 'Devoluciones en 30 días', 'Devoluciones en 14 días');

    const firstTrustItem = document.querySelector('.velomint-trust-strip__item');
    if (firstTrustItem) {
      const strong = firstTrustItem.querySelector('strong');
      const small = firstTrustItem.querySelector('small');
      if (strong) strong.textContent = 'Devoluciones 14 días';
      if (small) small.textContent = 'Compra protegida';
    }
  };

  const cleanPolicy = () => {
    const root = document.querySelector('.shopify-policy__body') || document.querySelector('.shopify-policy__container');
    if (!root) return;

    const path = window.location.pathname.toLowerCase();
    const replacements = [];

    if (path.includes('/policies/shipping-policy')) {
      replacements.push(['[tu email de contacto]', 'info@velomint.es']);
    }

    if (path.includes('/policies/contact-information')) {
      replacements.push(['Número de IVA: —', '']);
      replacements.push(['Número comercial: —', '']);
    }

    if (path.includes('/policies/refund-policy') || path.includes('/policies/terms-of-service')) {
      replacements.push(['30 días', '14 días']);
      replacements.push(['30 days', '14 days']);
      replacements.push(['info@velomint.com', 'info@velomint.es']);
    }

    replacements.forEach(([from, to]) => replaceText(root, from, to));
  };

  const productCache = new Map();
  let brandObserver = null;
  let brandMutationObserver = null;

  const normalize = (value) => String(value || '').trim().toLocaleLowerCase();

  const titleStartsWithVendor = (title, vendor) => {
    const cleanTitle = String(title || '').trim();
    const cleanVendor = String(vendor || '').trim();
    if (!cleanTitle || !cleanVendor) return false;
    const titleLower = normalize(cleanTitle);
    const vendorLower = normalize(cleanVendor);
    if (!titleLower.startsWith(vendorLower)) return false;
    const boundary = cleanTitle.charAt(cleanVendor.length);
    return !boundary || /[\s\-–—:|/]/.test(boundary);
  };

  const productJsonUrlFromCard = (card) => {
    const link = card.querySelector('.card__heading a[href*="/products/"]');
    if (!link) return null;
    try {
      const url = new URL(link.href, window.location.origin);
      url.search = '';
      url.hash = '';
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      return url.toString();
    } catch (_) {
      return null;
    }
  };

  const getProductData = (url) => {
    if (!url) return Promise.resolve(null);
    if (!productCache.has(url)) {
      productCache.set(
        url,
        fetch(url, { headers: { Accept: 'application/json' } })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null),
      );
    }
    return productCache.get(url);
  };

  const renderBrandFirst = (card, product) => {
    if (!card || !product) return;
    const vendor = String(product.vendor || '').trim();
    const title = String(product.title || '').trim();
    if (!vendor || !title) return;

    let model = title;
    if (titleStartsWithVendor(title, vendor)) {
      model = title.slice(vendor.length).replace(/^[\s\-–—:|/]+/, '').trim();
    }

    card.querySelectorAll('.card__heading a.full-unstyled-link').forEach((link) => {
      if (link.dataset.velomintBrandFirst === 'true') return;
      link.textContent = '';

      const brand = document.createElement('strong');
      brand.className = 'velomint-card-brand';
      brand.textContent = vendor;
      link.appendChild(brand);

      if (model) {
        link.appendChild(document.createTextNode(` ${model}`));
      }
      link.dataset.velomintBrandFirst = 'true';
    });
  };

  const hydrateBrand = async (card) => {
    if (!card || card.dataset.velomintBrandLoading === 'true' || card.dataset.velomintBrandDone === 'true') return;
    const url = productJsonUrlFromCard(card);
    if (!url) return;

    card.dataset.velomintBrandLoading = 'true';
    const product = await getProductData(url);
    delete card.dataset.velomintBrandLoading;

    if (product) {
      renderBrandFirst(card, product);
      card.dataset.velomintBrandDone = 'true';
    }
  };

  const observeCard = (card) => {
    if (!(card instanceof Element) || card.dataset.velomintBrandObserved === 'true') return;
    card.dataset.velomintBrandObserved = 'true';
    if (brandObserver) {
      brandObserver.observe(card);
    } else {
      hydrateBrand(card);
    }
  };

  const scanProductCards = (root = document) => {
    if (!root) return;
    if (root.matches?.('.product-card-wrapper')) observeCard(root);
    root.querySelectorAll?.('.product-card-wrapper').forEach(observeCard);
  };

  const setupBrandFirst = () => {
    if (!document.getElementById('velomint-brand-first-style')) {
      const style = document.createElement('style');
      style.id = 'velomint-brand-first-style';
      style.textContent = '.product-card-wrapper .velomint-card-brand{font-weight:800;}.product-card-wrapper .card-information > .caption-with-letter-spacing.light{display:none!important;}';
      document.head.appendChild(style);
    }

    if (!brandObserver && 'IntersectionObserver' in window) {
      brandObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            brandObserver.unobserve(entry.target);
            hydrateBrand(entry.target);
          });
        },
        { rootMargin: '500px 0px', threshold: 0.01 },
      );
    }

    scanProductCards(document);

    if (!brandMutationObserver) {
      brandMutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node instanceof Element) scanProductCards(node);
          });
        });
      });
      brandMutationObserver.observe(document.body, { childList: true, subtree: true });
    }
  };

  const run = () => {
    syncReturnMessage();
    cleanPolicy();
    setupBrandFirst();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
